export const CHART_BORDER_COLORS = {
  red: "rgb(255, 99, 132)",
  orange: "rgb(255, 159, 64)",
  yellow: "rgb(255, 205, 86)",
  lightGreen: "rgb(75, 192, 192)",
  blue: "rgb(54, 162, 235)",
  purple: "rgb(153, 102, 255)",
  grey: "rgb(201, 203, 207)",
};

export const CHART_COLORS = {
  red: "rgba(255, 99, 132,0.1)",
  orange: "rgba(255, 159, 64,0.1)",
  yellow: "rgba(255, 205, 86,0.1)",
  lightGreen: "rgba(75, 192, 192,0.1)",
  blue: "rgba(54, 162, 235,0.1)",
  purple: "rgba(153, 102, 255,0.1)",
  grey: "rgba(201, 203, 207,0.1)",
};

export const CHART_OTHER_COLORS = {
  red: "rgba(255, 99, 132,0.5)",
  orange: "rgba(255, 159, 64,0.5)",
  yellow: "rgba(255, 205, 86,0.5)",
  lightGreen: "rgba(75, 192, 192,0.5)",
  blue: "rgba(54, 162, 235,0.5)",
  purple: "rgba(153, 102, 255,0.5)",
  grey: "rgba(201, 203, 207,0.5)",
};

export const NEW_CHART_COLORS: { [key: number]: string } = {
  0: "#ED4C2F",
  1: "#1C1632",
  2: "#048673",
  3: "#AA2254",
  4: "#CC8F00",
  5: "#503E8E",
  6: "#06C6A9",
  7: "#DD5587",
};

export default CHART_COLORS;
